<template>
  <div class="hg-editor-content">
    <EditorContent :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2';

import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';

// Editor Tools
import Heading from '@tiptap/extension-heading';
import Link from '@tiptap/extension-link';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Strike from '@tiptap/extension-strike';
import Underline from '@tiptap/extension-underline';
import HardBreak from '@tiptap/extension-hard-break';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'

const HgLink = Link.extend({
  addAttributes() {
    return {
      href: {
        default: null,
      },
      'data-partner': {
        default: null,
      },
      class: {
        default: 'hg-text-link',
      },
      target: {
        default: '_blank',
      },
      rel: {
        default: 'noopener',
      },
    };
  },
});

export default {
  name: 'HgEditor',
  components: {
    EditorContent,
    // EditorMenuBar,
  },
  props: {
    content: {
      type: [Object, String],
      default: () => {},
    },
  },
  data() {
    return {
      // Create an `Editor` instance with some default content. The editor is
      // then passed to the `EditorContent` component as a `prop`
      editorConfig: {
        extensions: [
          Document,
          Paragraph,
          Text,
          Heading.configure({
            levels: [3, 4, 5, 6],
          }),
          BulletList,
          HgLink,
          Bold,
          ListItem,
          OrderedList,
          Italic,
          Strike,
          Underline,
          HardBreak,
          Table,
          TableCell,
          TableHeader,
          TableRow,
        ],
        content: this.content,
        editable: false,
      },
    };
  },
  computed: {
    editor() {
      return new Editor(this.editorConfig);
    },
  },
  mounted() {
    this.editor.commands.setContent(this.content);
  },
  beforeDestroy() {
    // Always destroy your editor instance when it's no longer needed
    this.editor.destroy();
  },
};
</script>

<style lang="scss" scoped>
.hg-editor-content p {
  margin: 0 !important;
}

.hg-editor-content {
  text-align: justify;

  &::v-deep a {
    color: $teal-600;

    &:hover {
      text-decoration: underline;
      color: $teal-700;
    }
  }

  &::v-deep h3 {
    font-size: rem(20);
    font-weight: bold;
    line-height: rem(23);
  }

  &::v-deep h4 {
    font-size: rem(18);
    font-weight: bold;
    line-height: rem(21);
  }

  &::v-deep h5 {
    font-size: rem(16);
    font-weight: bold;
    line-height: rem(19);
  }

  &::v-deep h6 {
    font-size: rem(14);
    font-weight: bold;
    line-height: rem(17);
  }
}
</style>
